module.exports = __webpack_public_path__ + "img/wangyusuo.760b4940.jpg";